export default "__VITE_ASSET__QmMPdRr2__"